<template>
  <!-- Footer -->
  <footer class="main_footer" role="footer">
    <div class="footer-container">
      <div class="mdc-layout-grid__inner border-bottom pb-4">
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-6-desktop mdc-layout-grid__cell--span-8-tablet mdc-layout-grid__cell--span-4-phone"
        >
          <h6>Surfverse</h6>
          <p>
            {{ $t('about_surfverse') }}
          </p>
          <ul class="footer-list">
            <li>
              <router-link class="footer-link" to="/about">{{
                $t('about')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/engineering">{{
                $t('engineering')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/press">{{
                $t('press')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/careers">{{
                $t('careers')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/people">{{
                $t('people')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/design">{{
                $t('design')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/developers">{{
                $t('developers')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/changelog">{{
                $t('changelog')
              }}</router-link>
            </li>
          </ul>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
        >
          <h6>{{ $t('features') }}</h6>
          <ul id="features" class="footer-list">
            <li>
              <router-link class="footer-link" to="/features/radar">{{
                $t('radar')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/features/studio">{{
                $t('studio')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/features/profiles">{{
                $t('profiles')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/features/chat">{{
                $t('chat')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/features/maps">{{
                $t('maps')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/features/smart-contracts">{{
                $t('smartcontracts')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/features/dark-mode">{{
                $t('darkmode')
              }}</router-link>
            </li>
          </ul>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-1-tablet mdc-layout-grid__cell--span-2-phone"
        >
          <h6>{{ $t('business') }}</h6>
          <ul class="footer-list">
            <li>
              <router-link class="footer-link" to="/business/radar">{{
                $t('radar')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/business/marketing">{{
                $t('marketing')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/business/recruit">{{
                $t('recruit')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/business/invest">{{
                $t('invest')
              }}</router-link>
            </li>
            <li>
              <router-link class="footer-link" to="/business/pages">{{
                $t('pages')
              }}</router-link>
            </li>
          </ul>
        </div>
        <div
          class="mdc-layout-grid__cell mdc-layout-grid__cell--span-2-desktop mdc-layout-grid__cell--span-2-tablet mdc-layout-grid__cell--span-2-phone"
        >
          <h6>{{ $t('lists') }}</h6>
          <ul class="footer-list">
            <li>{{ $t('persons') }}</li>
            <li>{{ $t('investors') }}</li>
            <li>{{ $t('jobs') }}</li>
            <li>{{ $t('startups') }}</li>
            <li>{{ $t('companies') }}</li>
            <li>{{ $t('salaries') }}</li>
            <li>{{ $t('recommended') }}</li>
            <li>{{ $t('announcements') }}</li>
            <li>{{ $t('education') }}</li>
            <li>{{ $t('news') }}</li>
          </ul>
        </div>
      </div>
      <div class="row p-3">
        <div class="col-lg-6 p-0">
          <p
            id="footer"
            class="mdc-typography--body2 text-color justify-content-start"
          >
            {{ $t('copyright') }}
            <a
              href="https://www.linkedin.com/in/mateesville"
              target="_blank"
              rel="noopener"
              >BOGDAN MATEESCU</a
            >
          </p>
        </div>
        <div class="col-lg-6 p-0 text-right d-none d-sm-block">
          <ul
            class="d-flex flex-row justify-content-end pr-0 unstyle-footer"
            id="unstyle"
          >
            <li>
              <a
                title="Follow Surfverse on Twitter"
                target="_blank"
                rel="noopener noreferrer"
                href="https://twitter.com/surfverse?utm_source=surfverse&amp;utm_medium=referral"
                class="_1g92g rm98t"
                ><svg
                  class="tw"
                  version="1.1"
                  viewBox="0 0 32 32"
                  width="32"
                  height="32"
                  aria-hidden="false"
                >
                  <path
                    d="M10.2 28.9c12 0 18.6-9.9 18.6-18.6v-.8c1.2-1 2.3-2.1 3.2-3.4-1.2.5-2.5.9-3.8 1 1.4-.8 2.4-2.1 2.9-3.6-1.3.8-2.7 1.3-4.2 1.6-2.5-2.6-6.6-2.8-9.2-.3-1.7 1.6-2.4 4-1.9 6.3-5.2-.3-10-2.8-13.4-6.9-1.7 3-.9 6.8 2 8.7-1 0-2.1-.3-3-.8v.1c0 3.1 2.2 5.8 5.3 6.4-1 .3-2 .3-3 .1.9 2.7 3.3 4.5 6.1 4.6-2.3 1.8-5.2 2.8-8.1 2.8-.5 0-1 0-1.6-.1 3.1 1.9 6.6 2.9 10.1 2.9"
                  ></path></svg
              ></a>
            </li>
            <li>
              <a
                title="Follow Surfverse on YouTube"
                target="_blank"
                rel="noopener noreferrer"
                href="https://youtube.com/surfverse?utm_source=surfverse&amp;utm_medium=referral"
                class="_1g92g rm98t"
                ><svg
                  class="yt"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M19.615 3.184c-3.604-.246-11.631-.245-15.23 0-3.897.266-4.356 2.62-4.385 8.816.029 6.185.484 8.549 4.385 8.816 3.6.245 11.626.246 15.23 0 3.897-.266 4.356-2.62 4.385-8.816-.029-6.185-.484-8.549-4.385-8.816zm-10.615 12.816v-8l8 3.993-8 4.007z"
                  /></svg
              ></a>
            </li>
            <li>
              <a
                title="Surfverse on GitHub"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.github.com/surfverse?utm_source=surfverse&amp;utm_medium=referral"
                class="_1g92g rm98t"
                ><svg
                  height="24"
                  class="gh octicon octicon-mark-github"
                  viewBox="0 0 16 16"
                  version="1.1"
                  width="24"
                  aria-hidden="true"
                >
                  <path
                    fill-rule="evenodd"
                    d="M8 0C3.58 0 0 3.58 0 8c0 3.54 2.29 6.53 5.47 7.59.4.07.55-.17.55-.38 0-.19-.01-.82-.01-1.49-2.01.37-2.53-.49-2.69-.94-.09-.23-.48-.94-.82-1.13-.28-.15-.68-.52-.01-.53.63-.01 1.08.58 1.23.82.72 1.21 1.87.87 2.33.66.07-.52.28-.87.51-1.07-1.78-.2-3.64-.89-3.64-3.95 0-.87.31-1.59.82-2.15-.08-.2-.36-1.02.08-2.12 0 0 .67-.21 2.2.82.64-.18 1.32-.27 2-.27.68 0 1.36.09 2 .27 1.53-1.04 2.2-.82 2.2-.82.44 1.1.16 1.92.08 2.12.51.56.82 1.27.82 2.15 0 3.07-1.87 3.75-3.65 3.95.29.25.54.73.54 1.48 0 1.07-.01 1.93-.01 2.2 0 .21.15.46.55.38A8.013 8.013 0 0016 8c0-4.42-3.58-8-8-8z"
                  ></path></svg
              ></a>
            </li>
            <li>
              <a
                title="Surfverse on LinkedIn"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.linkedin.com/company/surfverse?utm_source=surfverse&amp;utm_medium=referral"
                class="_1g92g rm98t"
                ><svg
                  class="in"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 0c-6.627 0-12 5.373-12 12s5.373 12 12 12 12-5.373 12-12-5.373-12-12-12zm-2 16h-2v-6h2v6zm-1-6.891c-.607 0-1.1-.496-1.1-1.109 0-.612.492-1.109 1.1-1.109s1.1.497 1.1 1.109c0 .613-.493 1.109-1.1 1.109zm8 6.891h-1.998v-2.861c0-1.881-2.002-1.722-2.002 0v2.861h-2v-6h2v1.093c.872-1.616 4-1.736 4 1.548v3.359z"
                  /></svg
              ></a>
            </li>
            <li>
              <a
                title="Follow Surfverse on Facebook"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.facebook.com/surfverse?utm_source=surfverse&amp;utm_medium=referral"
                class="_1g92g rm98t"
                ><svg
                  class="fb"
                  version="1.1"
                  viewBox="0 0 32 32"
                  width="32"
                  height="32"
                  aria-hidden="false"
                >
                  <path
                    d="M32 16.1c0-8.9-7.2-16-16-16S0 7.2 0 16.1c0 8 5.9 14.6 13.5 15.8V20.7H9.4v-4.6h4.1v-3.5c0-4 2.4-6.2 6-6.2 1.8 0 3.6.3 3.6.3v3.9h-2c-2 0-2.6 1.2-2.6 2.5v3h4.4l-.7 4.6h-3.7v11.2C26.1 30.7 32 24.1 32 16.1"
                  ></path></svg
              ></a>
            </li>
            <li>
              <a
                title="Follow Surfverse on Dribbble"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.dribbble.com/surfverse?utm_source=surfverse&amp;utm_medium=referral"
                class="_1g92g rm98t"
                ><svg
                  class="dr"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M12 0c-6.628 0-12 5.373-12 12s5.372 12 12 12 12-5.373 12-12-5.372-12-12-12zm9.885 11.441c-2.575-.422-4.943-.445-7.103-.073-.244-.563-.497-1.125-.767-1.68 2.31-1 4.165-2.358 5.548-4.082 1.35 1.594 2.197 3.619 2.322 5.835zm-3.842-7.282c-1.205 1.554-2.868 2.783-4.986 3.68-1.016-1.861-2.178-3.676-3.488-5.438.779-.197 1.591-.314 2.431-.314 2.275 0 4.368.779 6.043 2.072zm-10.516-.993c1.331 1.742 2.511 3.538 3.537 5.381-2.43.715-5.331 1.082-8.684 1.105.692-2.835 2.601-5.193 5.147-6.486zm-5.44 8.834l.013-.256c3.849-.005 7.169-.448 9.95-1.322.233.475.456.952.67 1.432-3.38 1.057-6.165 3.222-8.337 6.48-1.432-1.719-2.296-3.927-2.296-6.334zm3.829 7.81c1.969-3.088 4.482-5.098 7.598-6.027.928 2.42 1.609 4.91 2.043 7.46-3.349 1.291-6.953.666-9.641-1.433zm11.586.43c-.438-2.353-1.08-4.653-1.92-6.897 1.876-.265 3.94-.196 6.199.196-.437 2.786-2.028 5.192-4.279 6.701z"
                  /></svg
              ></a>
            </li>
            <li>
              <a
                title="Follow Surfverse on Behance"
                target="_blank"
                rel="noopener noreferrer"
                href="https://www.behance.com/surfverse?utm_source=surfverse&amp;utm_medium=referral"
                class="_1g92g rm98t"
                ><svg
                  class="be"
                  xmlns="http://www.w3.org/2000/svg"
                  width="24"
                  height="24"
                  viewBox="0 0 24 24"
                >
                  <path
                    d="M8.84 10.835h-1.965v-1.859h1.783c1.878 0 1.646 1.859.182 1.859zm5.789 1.058h2.624c-.115-1.687-2.36-1.81-2.624 0zm-5.9.396h-1.854v1.947h1.824c1.782-.001 1.673-1.947.03-1.947zm15.271-.289c0 6.627-5.373 12-12 12s-12-5.373-12-12 5.373-12 12-12 12 5.373 12 12zm-13.357-.733c1.668-.853 1.607-3.981-1.587-4.028h-4.056v8.73h3.771c3.958 0 3.891-3.967 1.872-4.702zm3.357-3.166h4v-.875h-4v.875zm4.943 3.693c-.545-3.505-6.053-3.711-6.053.872 0 4.526 5.18 3.818 5.949 1.56h-1.848c-.645.748-2.508.531-2.404-1.184h4.41c.009-.555-.009-.953-.054-1.248z"
                  /></svg
              ></a>
            </li>
          </ul>
        </div>
        <div class="col-lg-6 pt-3 p-0">
          <p
            id="footer"
            class="mdc-typography--body2 text-color justify-content-start"
          >
            {{ $t('hello') }}
          </p>
        </div>
        <div class="col-lg-6 pt-3 p-0 d-flex justify-content-end">
          <div class="d-none d-sm-block">
            <ul class="footer-links d-flex align-items-center">
              <li>
                <router-link class="footer-link" to="/legal/terms">{{
                  $t('terms')
                }}</router-link>
              </li>
              <li>
                <router-link class="footer-link" to="/legal/privacy">{{
                  $t('privacy')
                }}</router-link>
              </li>
              <li>
                <router-link class="footer-link" to="/legal/cookies-policy">{{
                  $t('cookie')
                }}</router-link>
              </li>
              <i18n></i18n>
            </ul>
          </div>
        </div>
      </div>

      <!-- <p class="text-center">
      Toate construcțiile pe care le puteți admira pe acest website, dacă
      alegeți să faceți o excursie pe aceste meleaguri, au fost construite de o
      civilizație superioară cu care noi nu avem nicio legătură...
    </p>
    <p class="text-center">Vă mulțumim!</p> -->
      <!-- <audio controls autoplay>
      <source src="/audio/mesaj.m4a" type="audio/mpeg" />
      Your browser does not support the audio element.
    </audio> -->
      <!-- <ul class="list-inline social-links mb-0"> 
            <li><a href="https://github.com/surfverse" target="_blank" class="btn-social btn-outline" data-toggle="tooltip" data-placement="top" title="Github"><ion-icon name="logo-github"></ion-icon></a>
            </li>
            <li><a href="https://twitter.com/surfverse" target="_blank" class="btn-social btn-outline" title="Twitter"><ion-icon name="logo-twitter"></ion-icon></a>
            </li>
            <li><a href="https://linkedin.com/company/surfverse" target="_blank" class="btn-social btn-outline" title="LinkedIn"><ion-icon name="logo-linkedin"></ion-icon></a>
            </li>
            <li><a href="https://instagram.com/surfverse" target="_blank" class="btn-social btn-outline" title="Instagram"><ion-icon name="logo-instagram"></ion-icon></a>
            </li>
            <li><a href="https://www.facebook.com/surfverse" target="_blank" class="btn-social btn-outline" title="Facebook"><ion-icon name="logo-facebook"></ion-icon></a>
            </li>
        </ul> -->
    </div>
  </footer>
</template>

<script>
import i18n from '@/components/i18n.vue'

export default {
  name: 'Footer',
  components: {
    i18n
  },
  methods: {
    setLocale(locale) {
      this.$i18n.locale = locale
      localStorage.setItem('locale', locale)
    }
  },
  created() {
    const locale = localStorage.getItem('locale')

    if (locale) {
      this.$i18n.locale = locale
    } else if (navigator.language) {
      this.$i18n.locale = navigator.language.substring(0, 2)
    }
  }
}
</script>

<i18n>
{
  "en": {
    "about_surfverse": "An online directory for startups, where people can search, post, like, vote, and track their favorite startups.",
    "about": "About",
    "engineering": "Engineering",
    "press": "Press",
    "careers": "Careers",
    "people": "People",
    "design": "Design",
    "developers": "Developers",
    "changelog": "Changelog",
    "features": "Features",
    "radar": "Radar",
    "studio": "Studio",
    "profiles": "Profiles",
    "chat": "Chat",
    "maps": "Maps",
    "smartcontracts": "Smart Contracts",
    "darkmode": "Dark Mode",
    "business": "For Companies",
    "creators": "For Creators",
    "marketing": "Marketing",
    "sales": "Sales",
    "recruit": "Recruit",
    "invest": "Invest",
    "pages": "Pages",
    "lists": "Lists",
    "persons": "Persons",
    "investors": "Investors",
    "jobs": "Jobs",
    "startups": "Startups",
    "companies": "Companies",
    "salaries": "Salaries",
    "recommended": "Recommended",
    "education": "Educational institutions",
    "news": "News",
    "terms": "Terms",
    "privacy": "Privacy",
    "cookie": "Cookies",
    "copyright": "© 2020 SURFVERSE FROM",
    "hello": "Hello from Medgidia.👋"
  },
  "ro": {
    "about_surfverse": "Un director online pentru startup-uri, unde oamenii pot căuta, posta, aprecia, vota și urmări startup-urile lor preferate.",
    "about": "Despre",
    "engineering": "Inginerie",
    "press": "Presă",
    "careers": "Angajări",
    "people": "Oameni",
    "design": "Design",
    "developers": "Dezvoltatori",
    "changelog": "Jurnal actualizări",
    "features": "Caracteristici",
    "radar": "Radar",
    "studio": "Studio",
    "profiles": "Profile",
    "chat": "Chat",
    "maps": "Hărți",
    "smartcontracts": "Contracte inteligente",
    "darkmode": "Modul întunecat",
    "business": "Pentru companii",
    "creators": "Pentru creatori",
    "marketing": "Comercializare",
    "sales": "Vânzări",
    "recruit": "Recrutări",
    "invest": "Investiţii",
    "pages": "Pagini",
    "lists": "Liste",
    "persons": "Persoane",
    "investors": "Investitori",
    "jobs": "Job-uri",
    "startups": "Startup-uri",
    "companies": "Companii",
    "salaries": "Salarii",
    "recommended": "Recomandate",
    "education": "Instituții de învăţământ",
    "news": "Știri",
    "terms": "Termeni",
    "privacy": "Confidențialitate",
    "cookie": "Cookie-uri",
    "copyright": "© 2020 SURFVERSE DE LA",
    "hello": "Bună ziua de la Medgidia.👋"
  }
}
</i18n>

<style>
.footer-list li {
  padding-bottom: 8px;
}
ul.footer-list {
  list-style: none;
  padding: 0;
  margin: 0;
}
.footer-links li {
  display: inline-block;
}
.footer-links li + li {
  margin-left: 36px;
}
.footer-container {
  margin-left: auto;
  margin-right: auto;
  margin-top: 150px;
  max-width: 1440px;
  -webkit-box-sizing: border-box;
  box-sizing: border-box;
  padding: var(--mdc-layout-grid-margin-desktop, 24px);
}
.footer-link {
  text-decoration: none;
  color: var(--text-color);
  transition: color 0.1s ease-in-out, opacity 0.1s ease-in-out;
  -webkit-text-decoration-skip: ink;
  text-decoration-skip-ink: auto;
}
.card {
  background-color: var(--grid-cell);
  border: 1px solid rgba(0, 0, 0, 0.38);
}
.card-header {
  background-color: var(--grid-cell);
  border-bottom: rgba(0, 0, 0, 0.38);
}
.unstyle-footer > li > a > svg {
  width: 24px !important;
  height: 24px !important;
}

#mc-embedded-subscribe-form input[type='checkbox'] {
  display: inline;
  width: auto;
  margin-right: 10px;
}
#mergeRow-gdpr {
  margin-top: 20px;
}
#mergeRow-gdpr fieldset label {
  font-weight: normal;
}
#mc-embedded-subscribe-form .mc_fieldset {
  border: none;
  min-height: 0px;
  padding-bottom: 0px;
}
#mc_embed_signup {
  background: transparent;
  clear: left;
  font: 14px Helvetica, Arial, sans-serif;
  width: 100%;
}
/* Add your own Mailchimp form style overrides in your site stylesheet or in this style block.
     We recommend moving this block and the preceding CSS link to the HEAD of your HTML file. */

button.btn.btn-link {
  font-family: Oswald;
  font-size: 24px;
  color: #ffc107;
}
.btn.btn-link.focus,
.btn.btn-link:focus {
  outline: 0;
  box-shadow: unset;
}
.locale-changer {
  max-width: 15em;
  min-width: 7em;
  float: right;
  margin-left: 30px;
}
@media (max-width: 576px) {
  #unstyle {
    display: none;
  }
  p#footer {
    text-align: center;
    margin: 0;
  }
}
</style>
